// src/layouts/RootLayout.tsx
import { ThemeProvider } from '../context/ThemeContext'
import { Toaster } from '@/components/ui/toaster'
import { ThemeBrandingSync } from '@/components/ThemeBrandingSync'

type RootLayoutProps = {
  children: React.ReactNode;
};

const RootLayout = ({ children }: RootLayoutProps) => {
    return (
        <ThemeProvider defaultTheme="system">
            <ThemeBrandingSync />
            <div className="app-container">
                {children}   {/* This is where routes or pages will be injected */}
            </div>
            <Toaster />
        </ThemeProvider>
    )
}

export default RootLayout;
